import * as ViewPage from "@/router/modules/view.apizip.module";

export const unzipView = [
  // static path
  {
    path: "/:pathMatch(.*)",
    name: "error-view",
    component: ViewPage.viewError,
    isAuthenticated: true,
    title: "DSI Admin - 404 View",
  },
  {
    path: "/login",
    name: "login-view",
    component: ViewPage.viewLogin,
    isAuthenticated: false,
    title: "DSI Admin - Login View",
  },
];
